import React, { useEffect, useRef, useState } from "react";
import "../signin.css";
import { Form, Input, InputNumber, Select, Spin } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/img/ndovuPayShield.png";
import PhoneInput from "react-phone-input-2";
import { counties } from "../../../counties";
import { saveNoToken } from "../../../features/save/saveSlice";
import toast from "react-hot-toast";

function Signup() {
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authLoading } = useSelector((state) => state.auth);

  const handleResetPassword = () => {
    navigate("/reset-password");
  };

  const onFinish = async (data) => {
    const res = await dispatch(
      saveNoToken({
        url: "api/v2/credit/create-invoice",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await navigate("/login");
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="slanted-background-signup">
        <div className="flex xl:px-[10.31rem]  h-full overflow-hidden">
          <div className="w-full xl:w-fit h-full flex justify-center items-center">
            <div
              style={{
                borderRadius: "0.83731rem",
                background: "#E0E9FF",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                width: "100%",
              }}
              className="w-fit flex flex-col lg:px-[2.28rem] px-3 py-[20px]"
            >
              <span className="flex items-center">
                <img src={logo} alt="logo" className="w-[50px]" />
                <div className="text-darkBlue text-[34px] font-[600]">
                  Ndovu<span className="text-[#DB2A12] font-[800]">HR</span>
                </div>
              </span>
              <div className="mt-5 text-darkBlue font-[600] text-[18px]">
                Request a Demo
              </div>
              <Form
                layout="vertical"
                ref={formRef}
                name="control-ref"
                onFinish={onFinish}
                style={{
                  maxWidth: "100%",
                  marginTop: "1.87rem",
                }}
                className="lg:w-[450px] w-full"
                form={form}
              >
                <Form.Item
                  className="table-form-item"
                  name="docId"
                  label={
                    <span>
                      Name <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please add name",
                    },
                  ]}
                >
                  <Input placeholder="Enter name" className="input" />
                </Form.Item>

                <Form.Item
                  name="usrEmail"
                  label={
                    <span>
                      Enter Email <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Add email address",
                    },
                    {
                      type: "email",
                      message: "Enter a valid email",
                    },
                  ]}
                >
                  <Input placeholder="Enter email" className="input" />
                </Form.Item>

                <Form.Item
                  name="usrMobileNumber"
                  label={
                    <span>
                      Phone No <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Enter phone number",
                    },
                  ]}
                >
                  <PhoneInput
                    country="ke"
                    onlyCountries={["ke"]}
                    countryCodeEditable={false}
                    className="input"
                  />
                </Form.Item>

                <Form.Item
                  name="senderId"
                  className=""
                  label={
                    <span>
                      Select County <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please select sender name",
                    },
                  ]}
                >
                  <Select
                    className=""
                    allowClear
                    style={{
                      width: "100%",
                    }}
                    options={
                      counties?.length > 0 &&
                      counties?.map((item) => ({
                        value: item?.name,
                        label: item?.name,
                      }))
                    }
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label?.toLocaleLowerCase() ?? "").includes(
                        input?.toLocaleLowerCase()
                      )
                    }
                    onDropdownVisibleChange={() => {}}
                  />
                </Form.Item>

                <Form.Item
                  className="table-form-item"
                  name="docId"
                  label={
                    <span>
                      Company Name <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please add company name",
                    },
                  ]}
                >
                  <Input className="input-login" />
                </Form.Item>

                <Form.Item
                  className="table-form-item"
                  name="docId"
                  label={
                    <span>
                      Number of employees
                      <span className="text-[#FF0000]">*</span>
                    </span>
                  }
                  rules={[
                    {
                      required: true,
                      message: "Please add number of employees",
                    },
                  ]}
                >
                  <InputNumber
                    min={0}
                    formatter={(value) =>
                      `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }
                    parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
                    placeholder="Enter number of employees"
                    className="input flex"
                  />
                </Form.Item>

                <div className="flex justify-center w-full mt-[2.94rem]">
                  <button
                    className="cstm-btn !bg-orange"
                    type="submit"
                    disabled={authLoading ? true : false}
                  >
                    {authLoading ? <Spin /> : "Submit"}
                  </button>
                </div>

                <div className="w-full flex justify-center items-center mt-[2.5rem]">
                  <span className="paragraph_paragraph_3 !text-black21">
                    Already have an account?{" "}
                  </span>
                  <Link
                    type="button"
                    className="!text-[#1B47B4] paragraph_paragraph_3 ml-[.2rem] underline"
                    to={"/login"}
                  >
                    Login
                  </Link>
                </div>
              </Form>
            </div>
          </div>
          <div className="w-full hidden xl:flex justify-center items-end flex-col"></div>
        </div>
      </div>
    </div>
  );
}

export default Signup;
